import Vue from "vue"
import "./plugins/vuetify"
import "./filters/initials"
import "./filters/localize"
import App from "./App.vue"
import "./registerServiceWorker"

Vue.config.productionTip = false

new Vue(App).$mount("#app")
